import { useNavigate } from "react-router-dom";

const NavigateButton = ({ text, margin }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <button
      onClick={handleClick}
      className="navigate_button"
      style={{ marginBlock: margin }}
    >
      {text}
    </button>
  );
};

export default NavigateButton;
